// src/utils/time.js

/**
 * Проверяет, может ли пользователь получить ежедневную награду.
 * @param {string | null} lastClaimedISO - Дата последней награды в формате ISO 8601.
 * @returns {boolean} - true, если может получить, иначе false.
 */
export function canClaimDailyReward(lastClaimedISO) {
  
  if (!lastClaimedISO) {
    return true; // Никогда не получал, значит, может
  }
  
  const lastClaimDate = new Date(lastClaimedISO);
  const now = new Date();
  
  // Вычисляем начало "сегодняшнего дня" в Екатеринбурге (UTC+5)
  // Полночь в ЕКБ - это 19:00 UTC предыдущего дня.
  const todayYekaterinburgStart = new Date();
  todayYekaterinburgStart.setUTCHours(19, 0, 0, 0);

  if (now < todayYekaterinburgStart) {
    // Если сейчас раньше 19:00 UTC, значит "сегодня" в ЕКБ еще не наступило с 19:00 UTC.
    // Поэтому "начало сегодняшнего дня" было вчера в 19:00 UTC.
    todayYekaterinburgStart.setUTCDate(todayYekaterinburgStart.getUTCDate() - 1);
  }
  
  return lastClaimDate < todayYekaterinburgStart;
}
export function getTimeUntilNextClaim() {
  const now = new Date();
  
  // Вычисляем "сегодняшнюю" полночь в ЕКБ, которая уже наступила
  const todayYekaterinburgStart = new Date();
  todayYekaterinburgStart.setUTCHours(19, 0, 0, 0); // 00:00 YEK_TIME is 19:00 UTC previous day

  if (now < todayYekaterinburgStart) {
    // Если сейчас раньше 19:00 UTC, то "начало сегодняшнего дня" было вчера
    todayYekaterinburgStart.setUTCDate(todayYekaterinburgStart.getUTCDate() - 1);
  }
  
  // Следующая возможность будет через 24 часа после "начала сегодняшнего дня"
  const nextClaimTime = new Date(todayYekaterinburgStart);
  nextClaimTime.setUTCDate(nextClaimTime.getUTCDate() + 1);
  
  return nextClaimTime - now; // Разница в миллисекундах
}